var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-table',{staticClass:"synaplus-cosmo-scroll-higher-720",attrs:{"responsive":"","striped":"","hover":"","fields":_vm.table_data.fields,"items":_vm.table_data.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }